import styled from "styled-components";

export const Menu = styled.div`
  margin-right: 0.5rem;
  cursor: pointer;
  visibility: hidden;
  @media (max-width: 768px) {
    visibility: visible;
  }
`;
